import React from 'react'
import { mount } from 'enzyme'

import Panel from '../Panel'

describe('<Panel />', () => {
  let wrapper, instance, props
  beforeEach(() => {
    props = {
      title: 'test title',
      onClick: () => {},
      onClickText: 'test text'
    }
    wrapper = mount(<Panel {...props} />)
    instance = wrapper.instance()
  })
  describe('#render', () => {
    describe('when an onClick prop is provided', () => {
      beforeEach(() => {
        wrapper.setProps({ onClick: jest.fn() })
        wrapper.update()
      })
      it('should render a link', () => {
        expect(wrapper.find('a')).toHaveLength(1)
      })
      it('it should render a link with the provided onClickText', () => {
        expect(wrapper.find('a').text()).toEqual(props.onClickText)
      })
      it('should call its onClick prop when the link is clicked', () => {
        wrapper.find('a').simulate('click')
        expect(wrapper.prop('onClick')).toHaveBeenCalledTimes(1)
      })
    })
    describe('when there is no onClick prop provided', () => {
      beforeEach(() => {
        wrapper.setProps({ onClick: null })
      })
      it('should not render a link', () => {
        expect(wrapper.find('a')).toHaveLength(0)
      })
    })
  })
})
